import React from 'react';
import {
  Empty, StandardCard, Button,
} from '@routific/hive';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useStore } from '../../../../../../store/mst';

// need this for vertical alignment, can remove later if we introduce StartEndTimelineCards in empty state
const StyledStandardCard = styled(StandardCard)`
height: 100%;

.ant-card-body {
  height: 100%;
}
`;

const StyledButton = styled(Button)`
   &:focus, &:active {
      transition: none;
   }
`;

const EmptyTimelineCard: React.FunctionComponent = () => {
  const store = useStore();
  const { t } = useTranslation('components');

  return (
    <StyledStandardCard stateless>
      <Empty
        size="large"
        title={t('emptyRoutes.title')}
        description={t('emptyRoutes.description')}
        button={(
          <StyledButton
            type="primary"
            size="middle"
            data-cy="schedule-orders-button"
            data-testid="schedule-orders-button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              store.schedulingWorkflow.openSchedulingPreview();
            }}
          >
            {t('emptyRoutes.button.text')}
          </StyledButton>
        )}
      />
    </StyledStandardCard>
  );
};

export default EmptyTimelineCard;
